module.exports = __webpack_public_path__ + "img/删除.ff26bf7c.png";